import React from "react";
import { AppContextType } from "../../../AppContext";
import IconButton from "../../theme_reuse/IconButton";

interface Props {}
interface State {}

export default class KeyMajorMinorButton extends React.Component<Props, State> {
  declare context: React.ContextType<typeof AppContextType>;

  handleToggleMajorMinor = () => {
    const keySelectionOptions = this.context.keySelectionOptions;
    this.context.dispatch({
      type: "EditKeySelectionOptions",
      payload: { ...keySelectionOptions, isPreferMajor: !keySelectionOptions.isPreferMajor },
    });
  };

  render() {
    const { isPreferMajor } = this.context.keySelectionOptions;
    const majMinIcon = <span className="icon-inner-letter">{isPreferMajor ? "M" : "m"}</span>;
    const majMinTitle = isPreferMajor ? "Prefer Major Key" : "Prefer Minor Key";
    return <IconButton mini title={majMinTitle} icon={majMinIcon} onClick={this.handleToggleMajorMinor} />;
  }
}

KeyMajorMinorButton.contextType = AppContextType;
